import { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface PlaceholderProps<OptionType extends CascaderOption>
  extends BoxProps {
  placeholder?: string;
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalPlaceholder = <OptionType extends CascaderOption>() => {
  const { cascaderStyles, comboboxApi, getCommonProps } =
    useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomPlaceholder = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.PLACEHOLDER),
    [getComponent],
  );
  const { placeholder } = comboboxApi.getInputProps();

  return (
    <CustomPlaceholder
      getCommonProps={getCommonProps}
      __css={cascaderStyles.placeholder}
      placeholder={placeholder}
      className="cascader-placeholder"
    >
      {placeholder}
    </CustomPlaceholder>
  );
};

export const Placeholder = <OptionType extends CascaderOption>({
  getCommonProps: _,
  placeholder,
  ...rest
}: PlaceholderProps<OptionType>) => {
  return <Box {...rest}>{placeholder}</Box>;
};
